import React, { useState } from "react";

import TabsComponent from "../../../../Components/Tab";
import { ComingSoonContent } from "../WorkspacePlaceholderCard";

type BriefingTab = "daily-synopsis" | "recent-signals";

type BriefingsCardProps = {
  className?: string;
};

const BRIEFING_TABS = [
  { id: "daily-synopsis", label: "Daily Synopsis" },
  { id: "recent-signals", label: "Recent Signals", disabled: true },
];

const BriefingsCard: React.FC<BriefingsCardProps> = ({ className = "" }) => {
  const [activeTab, setActiveTab] = useState<BriefingTab>("daily-synopsis");

  return (
    <section
      className={`box-border flex min-h-[280px] w-full min-w-0 flex-col overflow-hidden rounded-lg border border-[#EBEBEB] bg-white px-4 pb-3 pt-3.5 ${className}`}
    >
      <h2 className="m-0 shrink-0 text-base font-bold leading-6 text-black">
        Briefings
      </h2>
      <hr className="m-0 mb-3 mt-3 w-full shrink-0 border-0 border-t border-[#F6F6F6]" />

      <div className="shrink-0 border-b border-[#F6F6F6]">
        <TabsComponent
          tabs={BRIEFING_TABS}
          activeTab={activeTab}
          onTabChange={(id: string) => setActiveTab(id as BriefingTab)}
          variant="tab-underline"
        />
      </div>

      <div className="relative flex min-h-0 flex-1 overflow-hidden">
        {activeTab === "daily-synopsis" ? <ComingSoonContent /> : null}
      </div>
    </section>
  );
};

export default BriefingsCard;
